import { render, staticRenderFns } from "./device-item-view.vue?vue&type=template&id=67fbc2ec&"
import script from "./device-item-view.vue?vue&type=script&lang=js&"
export * from "./device-item-view.vue?vue&type=script&lang=js&"
import style0 from "./device-item-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports